import { NormalizeApi } from "../normalizeApi";
const BASE_ENDPOINT = 'gum-bridge.products';
export const ParseFilesApi = NormalizeApi({
  upload: `${BASE_ENDPOINT}.parse`
});